import users from "./users";
import credentials from "./credentials";
import me from "./me";
import urlshortener from "./urlshortener";

const servicecloud = {
    users,
    credentials,
    me,
    urlshortener,
};

export default servicecloud;
